import { ForwardedRef, forwardRef } from 'react';

import { V2, V2Types } from '@xemplo/popover';
import { List } from '@xemplo/stateful-list';

import { ActionListProps } from './action-list.types';

function ActionListInternal(
  props: ActionListProps,
  ref?: ForwardedRef<V2Types.PopoverRef>,
) {
  const { popoverProps, children, isMulti, listProps } = props;

  return (
    <V2.Popover.Root ref={ref} {...popoverProps}>
      <V2.Popover.Trigger>{children}</V2.Popover.Trigger>
      <V2.Popover.Popup asChild>
        {({ setOpen }) =>
          isMulti ? (
            <List.MultiSelect {...listProps} />
          ) : (
            <List.SingleSelect
              {...listProps}
              onChange={(selected) => {
                listProps.onChange?.(selected);
                if (props.closeOnSelect) {
                  setOpen(false); // Close the popover on selection
                }
              }}
            />
          )
        }
      </V2.Popover.Popup>
    </V2.Popover.Root>
  );
}

export const ActionList = forwardRef(ActionListInternal);
